import { countryDataset, CountrySelect } from 'components/Form'
import { getCountryByCode } from 'components/Form/countryCodes'
import { useMemo } from 'react'
import { AdvancedInputProps, BasicInputGroup } from '.'

export interface CountryInputProps extends AdvancedInputProps {
  value?: string
}

export const CountryInput = ({
  value,
  label,
  name,
  disabled,
  setFieldValue,
  onBlur,
  error,
  tabIndex,
}: CountryInputProps) => {
  const selected = useMemo(() => getCountryByCode(value), [value])
  const displayText = selected?.label || '-'

  return (
    <BasicInputGroup
      name={name}
      label={label}
      error={error}
      disabled={disabled}
      display={displayText}
      input={
        <CountrySelect
          data-cy="teaching-country"
          name={name}
          value={selected}
          options={countryDataset}
          hasErrors={!!error}
          disabled={disabled}
          onChange={(country) => {
            setFieldValue(name, country.countryCode)
          }}
          onBlur={onBlur}
          tabIndex={tabIndex}
        />
      }
    />
  )
}
